// extracted by mini-css-extract-plugin
module.exports =  {"desktop-banner":"_2787e5dfdf--desktop-banner--nil1M"};